import { Injectable } from '@angular/core';

@Injectable()
export class FchartalgoService {

  fstimestamp = null;
  options = {
    c_plana: true,
    interacumulador: true,
    forzado: true
  };
  consulta = {
    project: '',
    city: '',
    address: '',
    selectedProvince: null,
    volumen: 0,
    default_volumen: 0,
    units: 'Personas',
    tipovivienda: 2,
    num_unidades: 5,
    num_ocupantes: 15,
    accumulation: 0,
    centralization: 100,
    selectedProjectType: '',
    desviacion: 0,
    inclinacion: 40,
    contribucion: 60,
    contribucion_default: 0,
    temperatura_deseada: 60,
    perdidas: 0,
    zona: '',
    selected_normativa: true,
  };
  captadores;
  FSCaptadores = [];
  selectedCaptador = null;
  occ_rates = [100,100,100,100,100,100,100,100,100,100,100,100];

  DEFAULT_Solar_Radiation = 1; //1.00815;
  dias_mes=new Array(31,28,31,30,31,30,31,31,30,31,30,31);

  DEFAULT_accumulations = [100,150,200,250,300,350,400,450,500,1000,1500,2000,2500,3000,3500,4000,4500,5000,5500,
  6000,6500,7000,7500,8000,8500,9000,9500,10000,10500,11000,11500,12000,12500,13000,14500,15000,15500,16000,16500,
  17000,18500,19000,19500,20000];


  constructor() { }

  setOptions(options){
    this.options = options;
  }

  getOptions(){
    return this.options;
  }

  setConsulta(consulta){
    this.consulta = consulta;
    this.calculateAll();
  }


  resetCaptador(){
    this.consulta.accumulation = 150;
    this.updateAllFSCaptador(150, 1);
    if (this.selectedCaptador != null){
      this.selectedCaptador.accumulacion_optima = 150;
      this.selectedCaptador.accumulacion = 150;
    }
    this.fstimestamp = new Date();
  }

  updateAllFSCaptador(accumulation, number){
    this.consulta.accumulation = accumulation;
    for(var i=0; i < this.FSCaptadores.length; i++){
       this.FSCaptadores[i] = this.calculate(this.FSCaptadores[i], i, number, accumulation)
    }
  }


  getConsulta(){
    return this.consulta;
  }

  updateOccupancy(occrates){
    this.occ_rates = occrates;
    this.calculateAll();
  }

  getOccupancy(){
    return this.occ_rates;
  }

  setCaptadores(captadores){
    this.captadores = captadores;
  }

  getCaptadores(){
    return this.captadores;
  }

  getTimeStamp(){
    return this.fstimestamp;
  }

  getSelectedCaptador(){
    return this.selectedCaptador;
  }

  get_acs_total(){
    for (var i = 0; i < this.FSCaptadores.length; i++)
      if(this.FSCaptadores[i].captador == this.selectedCaptador){
        return this.FSCaptadores[i].acs_total;
      }
  }
  get_acs_total_default(){
    for (var i = 0; i < this.FSCaptadores.length; i++)
      if(this.FSCaptadores[i].captador == this.selectedCaptador){
        return this.FSCaptadores[i].acs_total_default;
      }
  }

  get_en_total(){
    for (var i = 0; i < this.FSCaptadores.length; i++)
      if(this.FSCaptadores[i].captador == this.selectedCaptador){
        return this.FSCaptadores[i].en_total;
      }
  }

  getContribucionAnual(){
    for (var i = 0; i < this.FSCaptadores.length; i++)
      if(this.FSCaptadores[i].captador == this.selectedCaptador){
        return this.FSCaptadores[i].contribucion_anual;
      }
  }

  getAccumulacionArea(){
    for (var i = 0; i < this.FSCaptadores.length; i++)
      if(this.FSCaptadores[i].captador == this.selectedCaptador){
        return this.FSCaptadores[i].accumulacion_area;
      }
  }

  getMas100(){
     for (var i = 0; i < this.FSCaptadores.length; i++)
      if(this.FSCaptadores[i].captador == this.selectedCaptador){
        return this.FSCaptadores[i].mas100;
      }
  }

  getMas110(){
     for (var i = 0; i < this.FSCaptadores.length; i++)
      if(this.FSCaptadores[i].captador == this.selectedCaptador){
        return this.FSCaptadores[i].mas110;
      }
  }

  setSelectedCaptador(captador, accumulation){
    this.selectedCaptador = captador;
    this.consulta.accumulation = accumulation;
  }

  getFSCaptadores(){
      return this.FSCaptadores;
  }

  getSelectedProvince(){
    if(this.consulta)
      return this.consulta.selectedProvince;
    else
      return null;
  }

  updateFSCaptador(captador, accumulation, number){
    this.consulta.accumulation = accumulation;
    for(var i=0; i < this.FSCaptadores.length; i++){
      if(this.FSCaptadores[i].captador == captador){
        var overall = this.FSCaptadores[i].contribucion_anual;
        var nb = number;
        var ele = null;
        while(overall >= this.consulta.contribucion && nb > 0){
          ele = this.calculate(captador, i, nb, accumulation);
          overall = ele.contribucion_anual;
          nb = nb - 1;
        }
        ele = this.calculate(captador, i, nb+2, accumulation);
        this.FSCaptadores[i] = ele;
        this.FSCaptadores[i].captador.accumulacion = this.FSCaptadores[i].accumulacion;
        this.FSCaptadores[i].captador.accumulacion_optima = this.FSCaptadores[i].accumulacion_optima;
        this.fstimestamp = new Date();
        break;
      }
    }
  }


  updateFSCaptadorManual(captador, accumulation, number){
    this.consulta.accumulation = accumulation;
    console.log(this.consulta.contribucion);
    for(var i=0; i < this.FSCaptadores.length; i++){
      if(this.FSCaptadores[i].captador == captador){
        this.FSCaptadores[i] = this.calculate(captador, i, number, accumulation);
        this.FSCaptadores[i].captador.accumulacion = this.FSCaptadores[i].accumulacion;
        this.FSCaptadores[i].captador.accumulacion_optima = this.FSCaptadores[i].accumulacion_optima;
        this.fstimestamp = new Date();
        break;
      }
    }
  }


  calculateAll(){
    if(this.captadores && this.consulta){
      var captadores = [];
      for (var i = 0; i < this.captadores.length; i++){
        var ele = null;
        var numero_captadores = 1;
        if (this.FSCaptadores && this.FSCaptadores[i])
          numero_captadores = this.FSCaptadores[i].nb;
        var overall = 0;
        var accumulation = 150;
        this.consulta.accumulation = 150;
        while(overall <= this.consulta.contribucion && numero_captadores < 150){  //
          accumulation = this.consulta.accumulation;
          ele = this.calculate(this.captadores[i], i, numero_captadores, accumulation);
          numero_captadores = numero_captadores + 1;
          overall = ele.contribucion_anual;
        }
        captadores.push(ele);
      }
      this.FSCaptadores = captadores;
    } else {
      console.log(this.consulta);
    }
    this.fstimestamp = new Date();
  }


  calculateAccumulation(ele){
    var accumulation = this.consulta.accumulation;
    ele.accumulacion_optima = accumulation;
    while(ele.accumulacion_area < 50 && ele.accumulacion_optima <=19500){
      var index = this.DEFAULT_accumulations.indexOf(ele.accumulacion_optima);
      if (index < 0) { //custom accumulation
        for (var l = 0; l < this.DEFAULT_accumulations.length; l++) {
          if (this.DEFAULT_accumulations[l] > ele.accumulacion_optima){
            index = l;
            break;
          }
          accumulation = this.DEFAULT_accumulations[index];
        }
      }
      else{
        index = index + 1;
        accumulation = this.DEFAULT_accumulations[index];
      }

      if (index < 0){
        index = 0;
        accumulation = this.DEFAULT_accumulations[0];
      }
     //accumulation = this.DEFAULT_accumulations[index];
      ele.accumulacion_area = accumulation / (ele.nb * ele.captador.superficie);
      ele.accumulacion_optima = accumulation;
    }

    while (ele.accumulacion_area > 180){
      var index = this.DEFAULT_accumulations.indexOf(ele.accumulacion_optima);
      if (index < 0) { //custom accumulation
        for (var l = this.DEFAULT_accumulations.length; l >= 0; l--) {
          if (this.DEFAULT_accumulations[l] < ele.accumulacion_optima){
            index = l;
            break;
          }
          accumulation = this.DEFAULT_accumulations[index];
        }
      }
      else{
        index = index - 1;
        accumulation = this.DEFAULT_accumulations[index];
      }

      if (index < 0){
        index = 0;
        accumulation = this.DEFAULT_accumulations[0];
      }
      //accumulation = this.DEFAULT_accumulations[index];
      ele.accumulacion_area = accumulation / (ele.nb * ele.captador.superficie);
      ele.accumulacion_optima = accumulation;
    }
    //console.log(accumulation);
    return accumulation;
  }


  calculate(captador, i, numero_captadores, accumulation){
    var R0 = captador.a0;
    var A1 = captador.a1;
    var A2 = captador.a2;

    /*
    if(A2!=0)
      A1 = 0.75*A1 + 16*Math.pow(A2*A1, 0.5);
      //if(te==0) {
    A1 = A1/(1 + 0.006*A1);
    R0=R0*(1 - 0.006*A1);
      // }
    */

    var factor_intercambio = captador.factor_intercambio;
    var superficie_total = numero_captadores * captador.superficie;
    var temperatura_deseada = this.consulta.temperatura_deseada;
    var volumen = this.consulta.volumen * this.consulta.num_ocupantes;
    var latitude = this.consulta.selectedProvince.lat;
    var inclinacion = this.consulta.inclinacion;
    var desviacion = this.consulta.desviacion;
    var average_radiation = this.consulta.selectedProvince.average_radiation;
    var temp_agua_fria = this.consulta.selectedProvince.coldwater_temperature.split(',');
    var temp_ambiante = this.consulta.selectedProvince.average_temperature;

    var fks = this.calculate_fksNew(latitude, inclinacion, average_radiation);
    var fbeta = this.calculate_fbeta(latitude, inclinacion, desviacion);

    var fks_default = this.calculate_fksNew(latitude, 40, average_radiation);
    var fbeta_default = this.calculate_fbeta(latitude, 40, 0);


    var rad=new Array(12);
    var rad_default=new Array(12);
    var En=new Array(12);
    var FS= new Array(12);
    var FS_default= new Array(12);
    var ACS = new Array(12);
    var ACS_default = new Array(12);

    var en_total = 0;
    var acs_total = 0;
    var acs_total_default = 0;

    var meses_con_mas_100 = 0;
    var meses_con_mas_110 = 0;

    for(var mes=1;mes<=12;mes++) {
      rad[mes-1] = fks[mes-1] * fbeta * 1000 * this.DEFAULT_Solar_Radiation * this.dias_mes[mes-1];  //kJ/mes
      rad_default[mes-1] = fks[mes-1] * fbeta_default * 1000 * this.DEFAULT_Solar_Radiation * this.dias_mes[mes-1];  //kJ/mes

      //Energia necesaria
      En[mes-1] = 4.184 * this.dias_mes[mes-1] * this.consulta.centralization * 0.01
                      * volumen * (temperatura_deseada - temp_agua_fria[mes-1]) * 0.01 * this.occ_rates[mes-1];

      en_total = en_total + En[mes-1]/3600;

      var valeFS = true;
      superficie_total = numero_captadores * captador.superficie;

      FS[mes-1] = this.calculate_FS(mes, accumulation, superficie_total, temperatura_deseada,
                                    factor_intercambio, temp_ambiante, temp_agua_fria,
                                    rad, En, R0, A1);
      FS_default[mes-1] = this.calculate_FS(mes, accumulation, superficie_total, temperatura_deseada,
                                    factor_intercambio, temp_ambiante, temp_agua_fria,
                                    rad_default, En, R0, A1);


      ACS[mes-1] = FS[mes-1]*En[mes-1]/3600;
      ACS_default[mes-1] = FS_default[mes-1]*En[mes-1]/3600;
      acs_total = acs_total + ACS[mes-1];
      acs_total_default = acs_total_default + ACS_default[mes-1];

      if(FS[mes-1]==-991) {
        FS[mes-1]="V/A!";
        valeFS=false;
      }
      else if(FS[mes-1]==-992) {
        FS[mes-1]="D1!";
        valeFS=false;
      }
      else if(FS[mes-1]==-993) {
        FS[mes-1]="D2!";
        valeFS=false;
      }
      else if(FS[mes-1]<0) {
        FS[mes-1]="ERR";
        valeFS=false;
      }
      else {
        FS[mes-1] = Math.round(10000 * FS[mes-1])/100;
        if (FS[mes-1] > 100)
          meses_con_mas_100 = meses_con_mas_100 + 1;
        if (FS[mes-1] >= 110)
          meses_con_mas_110 = meses_con_mas_110 + 1;
      }
    }

    if(valeFS==false) {
      console.log("_");
    }

    this.captadores[i].unidades = numero_captadores;

    var contrib_anual = 100 * acs_total / en_total;
    var acc_area = accumulation / (numero_captadores * captador.superficie);

    var ele = {
        values: FS,
        ACS: ACS,
        En: En,
        FS: FS,
        acs_total: acs_total,
        acs_total_default: acs_total_default,
        en_total: en_total,
        captador: captador,
        nb: numero_captadores,
        mas100: meses_con_mas_100,
        mas110: meses_con_mas_110,
        contribucion_anual: contrib_anual,
        accumulacion_area: acc_area,
        accumulacion: accumulation,
        accumulacion_optima: 150
    };

    ele.accumulacion_optima = this.calculateAccumulation(ele);
    return ele;
  }



    //tabla RAD en excel
    //RETURN 1 when inclination or desviacion = 0;
    calculate_fbeta(latitude,inclinacion,desviacion) {
      var dev = Math.abs(desviacion);
	    var fbeta = (1 - 0.0113 * Math.pow(Math.sin(inclinacion * Math.PI/180), 1.5) *
              Math.pow(dev, 2.32) * (dev - 1.648) *
              Math.pow(Math.pow(dev, 2.32) + 4237, -1)) *
	            (1 + 0.0058 * Math.pow(inclinacion, 0.5) * dev *
              (1 - 0.56 * Math.pow(Math.abs(latitude), 0.16) ) );
      return fbeta;
    }


    calculate_fksNew(latitude, inclinacion, average_radiation) {

    var radiant = Math.PI / 180;
    var rad23 = radiant * 23.45;
    var rad360 = (360*radiant)/365;
    var Nseries = [17, 47, 75, 105, 135, 162, 198, 228, 258, 288, 318, 344];

    var Hvalues = [];
      for(var mes=1;mes<=12;mes++) {
        var drad = rad23 * Math.sin(rad360 * (284 + Nseries[mes - 1]));
        var W1 = - Math.tan(radiant*latitude) * Math.tan(drad);
        var W1o = Math.atan(Math.sqrt(1- Math.pow(W1,2))/W1) /radiant;

        if (W1o < 0) W1o = W1o + 180;
        W1 = W1o;

        var W1RAD = W1*radiant;

        var H0o = W1RAD*Math.sin(latitude*radiant)*Math.sin(drad) +
                          Math.cos(latitude*radiant)* Math.cos(drad)*Math.sin(W1RAD);

        var H0 = (24 * (1353*3.6) / Math.PI) * ( 1 + 0.033*Math.cos(rad360*Nseries[mes -1])) * H0o;
        var K1 = average_radiation[mes-1] * 1000 / H0;
        var H1 = 1.39 - 4.03*K1 + 5.53*Math.pow(K1,2) - 3.11 * Math.pow(K1,3);
        var W2 = - Math.tan((latitude - inclinacion)*radiant) * Math.tan(drad);

        if (W2 == 0)
          W2 = 90;
        else
          W2 = Math.atan(Math.sqrt(1-Math.pow(W2,2))/W2) / radiant;

        if (W2 < 0) W2 = W2 + 180;

        var Wcomp = W2 * radiant;

        if (W2 > W1)
          Wcomp = W1 * radiant;

        var Ro = Math.cos(latitude*radiant)*Math.cos(drad)*Math.sin(W1RAD)+ W1RAD*Math.sin(latitude*radiant)*Math.sin(drad);
        var R = (Math.cos((latitude - inclinacion)*radiant) * Math.cos(drad) * Math.sin(Wcomp)
                 + Wcomp * Math.sin((latitude - inclinacion)*radiant)*Math.sin(drad))/Ro ;

        Hvalues[mes - 1] = average_radiation[mes-1]*((1 - H1)* R + H1*( 1 + Math.cos(inclinacion*radiant) )/2+0.2*(1- Math.cos(inclinacion*radiant) )/2);
      }
      return Hvalues;
    }


    calculate_FS(mes, accumulation, superficie_total, temperatura_deseada,
                  factor_intercambio, temp_ambiante, temp_agua_fria, rad, En, R0, A1) {
      var FS;
      var sd = 0.98;   //Cobertura simple  // ahora está a 0.98,
      //if(cubs==0) sd=0.94;

      //energia absorbida por los captadores
      var Ea = superficie_total * R0 * sd * factor_intercambio * rad[mes-1];

      //Factor de corrección por almacenamiento
      var k1 = Math.pow(accumulation/(75 * superficie_total) , -0.25);

      var delta = 24 * 3600 * this.dias_mes[mes-1];
      var k2 = (11.6
              + (1.18 * temperatura_deseada)
              + (3.86 * temp_agua_fria[mes-1])
              - (2.32 * temp_ambiante[mes-1])) / (100 - temp_ambiante[mes-1]);

      //Factor de corrección para A.C.S.
      var Ep = superficie_total * A1 * factor_intercambio * (100 - temp_ambiante[mes-1]) * delta * k1 * k2 ;



      //rendimiento medio del sistema
      var D1 = Ea / En[mes-1];
      var D2 = Ep / (1000 * En[mes-1]);

      /*
      if(accumulation/superficie_total<37.5 || accumulation/superficie_total>300)   FS=-991;
      else if(D1<0 || D1>3)     FS=-992;
      else if(D2<0 || D2>18)    FS=-993;
      else
      */

      FS = (1.029 * D1) - (0.065 * D2) - (0.245 * D1 * D1) + (0.0018 * D2 * D2) + (0.0215 * D1 * D1 * D1);
      return FS;
    }
}



// WEBPACK FOOTER //
// ./src/app/fchart/fchartalgo.service.ts